import type { BanNoticeRecord } from "@/types/auth";

export function formatBanNoticeExpiry(
  expiresAt: string,
  locales?: Intl.LocalesArgument,
) {
  const parsedValue = Date.parse(expiresAt);
  if (Number.isNaN(parsedValue)) {
    return null;
  }

  return new Intl.DateTimeFormat(locales, {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(parsedValue));
}

export function getBanNoticeTranslationInput(
  banNotice: BanNoticeRecord | null,
  locales?: Intl.LocalesArgument,
) {
  if (banNotice?.is_banned && banNotice.expires_at) {
    const formattedExpiresAt = formatBanNoticeExpiry(banNotice.expires_at, locales);
    if (formattedExpiresAt) {
      return {
        key: "auth.errors.accountBannedUntil" as const,
        values: {
          expiresAt: formattedExpiresAt,
        },
      };
    }
  }

  return {
    key: "auth.errors.accountBanned" as const,
    values: {},
  };
}
